export default __webpack_public_path__ + "static/media/C.52b07652.svg";